/**
 * Variables de las secciones de Mi Cuenta
 */
export const OPTION_HISTORIAL_PEDIDOS = 'history'
export const OPTION_MERCADOS = 'markets'
export const OPTION_TARJETAS = 'cards'
export const OPTION_DIRECCIONES = 'addresses'
export const OPTION_EDITAR_DATOS = 'edit_data'
